import { render, staticRenderFns } from "./EvolucionCostos.vue?vue&type=template&id=12828a3e&"
import script from "./EvolucionCostos.vue?vue&type=script&lang=js&"
export * from "./EvolucionCostos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports